export default "__VITE_ASSET__VZQix1DL__"